import { Icon } from "@iconify/react/dist/iconify.js";
import EmptyState from "../../components/UI/EmptyState";

const ESTADO_COLORS = {
  en_progreso: { bg: "bg-warning-subtle", text: "text-warning", label: "En progreso" },
  completado: { bg: "bg-success-subtle", text: "text-success", label: "Completado" },
};

const MisSesionesList = ({ sesiones, onVerResumen }) => {
  if (!sesiones || sesiones.length === 0) {
    return (
      <div className="card p-24 radius-12">
        <EmptyState
          icon="mdi:forum-outline"
          title="Sin sesiones"
          description="No tienes sesiones de conversación registradas."
        />
      </div>
    );
  }

  // Agrupar sesiones por talento
  const agrupadas = sesiones.reduce((acc, sesion) => {
    const talento = sesion.talento_nombre || "Sin talento";
    if (!acc[talento]) acc[talento] = [];
    acc[talento].push(sesion);
    return acc;
  }, {});

  return (
    <div className="mis-sesiones">
      <h5 className="mb-3">Historial de sesiones</h5>
      {Object.entries(agrupadas).map(([talento, sesionesGrupo]) => (
        <div key={talento} className="mb-4">
          {/* Encabezado del grupo */}
          <div className="d-flex align-items-center gap-2 mb-3">
            <Icon icon="mdi:star" width="20" className="text-warning" />
            <h6 className="mb-0 fw-bold">{talento}</h6>
            <span className="badge bg-warning-subtle text-warning">
              {sesionesGrupo.length} sesión(es)
            </span>
          </div>

          <div className="row g-3">
            {sesionesGrupo.map((sesion, idx) => {
              const estadoColor =
                ESTADO_COLORS[sesion.estado] || ESTADO_COLORS.completado;
              return (
                <div
                  key={sesion.id}
                  className="col-md-6 col-lg-4"
                >
                  <div className="card radius-12 p-16 h-100 sesion-card">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <span
                        className={`badge ${estadoColor.bg} ${estadoColor.text}`}
                      >
                        {estadoColor.label}
                      </span>
                      <span className="badge bg-primary-subtle text-primary">
                        #{sesion.conversacion_numero}
                      </span>
                    </div>

                    <h6 className="mb-2 sesion-card__pregunta">
                      {sesion.conversacion_pregunta}
                    </h6>

                    <div className="sesion-card__info">
                      <div className="d-flex align-items-center gap-1 text-secondary mb-1">
                        <Icon icon="mdi:account-tie" width="16" />
                        <small>{sesion.mentor_nombre}</small>
                      </div>
                      <div className="d-flex align-items-center gap-1 text-secondary mb-1">
                        <Icon icon="mdi:account-school" width="16" />
                        <small>{sesion.estudiante_nombre}</small>
                      </div>
                      <div className="d-flex align-items-center gap-1 text-secondary">
                        <Icon icon="mdi:message-text" width="16" />
                        <small>
                          {sesion.cantidad_respuestas} respuesta(s)
                        </small>
                      </div>
                    </div>

                    <div className="mt-3 pt-2 border-top">
                      <small className="text-muted d-block mb-2">
                        <Icon icon="mdi:calendar" width="14" className="me-1" />
                        {sesion.fecha_inicio}
                      </small>
                      <button
                        className="btn btn-sm btn-outline-primary w-100"
                        onClick={() => onVerResumen(sesion.id)}
                      >
                        <Icon icon="mdi:eye" className="me-1" />
                        Ver resumen
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MisSesionesList;
